var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_4832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3414 3.74502C20.3018 14.662 11.4562 23.4997 0.550049 23.4997C11.4805 23.4997 20.3414 32.3771 20.3414 43.3278C20.3808 32.4107 29.2267 23.5731 40.1328 23.5731C29.2021 23.5731 20.3414 14.6956 20.3414 3.74502Z",
    stroke: "url(#paint0_linear_169_4832)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.035 3.74463C39.02 7.88988 35.6613 11.2456 31.5201 11.2456C35.6705 11.2456 39.035 14.6164 39.035 18.7744C39.05 14.6292 42.4088 11.2734 46.5499 11.2734C42.3995 11.2734 39.035 7.90264 39.035 3.74463Z",
    stroke: "url(#paint1_linear_169_4832)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_4832",
    x1: -9.84957,
    y1: -194.375,
    x2: 137.091,
    y2: -112.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_4832",
    x1: 27.5713,
    y1: -71.4827,
    x2: 83.3655,
    y2: -40.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_4832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0.550293 0.536133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFeature3);
export default __webpack_public_path__ + "static/media/web_feature_3.ef2f4b2fd22c5b3b9c7da1e00b6029da.svg";
export { ForwardRef as ReactComponent };